var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "super-collection" },
    [
      _vm._l(_vm.linearSettingsArray, function(linearSettings, idx) {
        return _c("super-collection-linear", {
          key: idx,
          attrs: { settings: linearSettings }
        })
      }),
      _c("image-grid", {
        attrs: {
          align: "left",
          header: _vm.grid1Settings.header,
          header_link_text: _vm.grid1Settings.link_text,
          header_link_url: _vm.grid1Settings.link_url,
          cta_style: _vm.grid1Settings.cta_style,
          images: _vm.grid1Settings.images
        }
      }),
      _c("image-grid", {
        attrs: {
          align: "right",
          header: _vm.grid2Settings.header,
          header_link_text: _vm.grid2Settings.link_text,
          header_link_url: _vm.grid2Settings.link_url,
          cta_style: _vm.grid2Settings.cta_style,
          images: _vm.grid2Settings.images
        }
      }),
      _c("super-collection-product-tiles", {
        attrs: { settings: _vm.collectionSettings }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }